import React from 'react';

// PNG
import EV from '../media/icons/png/EV.png';
import Battery from '../media/icons/png/Battery.png';
import EK from '../media/icons/png/EK.png';
import Remote from '../media/icons/png/Remote.png';
import SW from '../media/icons/png/SW.png';
import VCU from '../media/icons/png/VCU.png';

function AboutOurWork() {
  const feature = [
    {
      icon: EV,
      title: 'EV Powertrain',
      text: `Implementation of custom powertrain in the field of electric mobility, working on high-voltage system with a high degree of engineering`,
    },
    {
      icon: Battery,
      title: 'Battery & BMS',
      text: `Custom BMS development and implementation of custom battery packs, offers maximum safety and reliability in various applications in the automotive and marine fields.`,
    },
    {
      icon: VCU,
      title: 'VCU',
      text: `Proprietary Vehicle Control Unit: Conforms to automotive standards, with high input/output and functionality CAN communication standard: J1939 ISO11899`,
    },
    {
      icon: SW,
      title: 'SW & FW',
      text: `Dedicated Software and Firmware development to better govern the components of the entire Powertrain`,
    },
    {
      icon: Remote,
      title: 'Remote Diagnostic',
      text: `System operation data are recorded and processed by specific algorithms, based on AI technologies, which will be able to predict possible faults`,
    },
    {
      icon: EK,
      title: 'Electrification Knowledge',
      text: `Engineering competence related to the development of electrified vehicles of an innovative kind. Following the customer from the idea to the finished product`,
    },
  ];

  return (
    <div>
      <section class="bg-gray-900 text-white">
        <div class="container mx-auto px-10 py-16 sm:px-6 lg:px-8">
          <div class="max-w-xl">
            <h2 class="text-3xl font-bold sm:text-4xl">Our Assets</h2>
          </div>

          <div className="grid grid-cols-1 gap-8 mt-8 md:mt-16 md:grid-cols-2 md:gap-12 lg:grid-cols-3">
            {feature &&
              feature.map((punto, id) => (
                <div key={id} className="flex items-start ">
                  <span className="flex-shrink-0 p-4 bg-gray-800 rounded-lg">
                    <img src={punto.icon} alt={punto.title} className="w-12" />
                  </span>
                  <div class="ml-4">
                    <h2 class="text-lg font-bold">{punto.title}</h2>
                    <p class="mt-1 text-sm text-gray-300">{punto.text}</p>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default AboutOurWork;
